// EPSG 관련 상수
export const EPSG = {
  EPSG_4326: "EPSG:4326",
  EPSG_3857: "EPSG:3857",
  EPSG_900913: "EPSG:900913",
} as const;

// Matrix Set 관련 상수
export const MATRIX_SET = {
  ...EPSG,
  GOOGLE_MAPS_COMPATIBLE: "GoogleMapsCompatible",
} as const;

// 타일 설정
export const TILE_CONFIG = {
  size: 256,
  maxZoomLevel: 25,
};
